// Lugares cercanos con puntuación (centro comercial, parque, etc.) de una propiedad.
export const NEARBY_CATEGORIES = [
  'Centro comercial',
  'Supermercado',
  'Restaurantes',
  'Parque',
  'Recreación',
  'Colegio',
  'Universidad',
  'Salud',
] as const;

// not_searched: viene de la IA y aún no se busca en Google; found: Places lo resolvió
// (coordenadas, nota y foto reales); not_found: Places no lo encontró (revisar a mano);
// saved: ya está guardado en la propiedad.
export type NearbyPlaceStatus = 'not_searched' | 'found' | 'not_found' | 'saved';

export interface NearbyPlaceDraft {
  id: string;
  name: string;
  address: string;
  category: string;
  rating: number | null;
  lat: number | null;
  lng: number | null;
  // URL de nuestro bucket (la que se guarda).
  image: string | null;
  // Foto de Google, solo para previsualizar y copiar al bucket; nunca se guarda tal cual.
  googlePhotoUrl: string | null;
  status: NearbyPlaceStatus;
}

export interface NearbySavePayload {
  nearby_places: Array<{
    id: string;
    name: string;
    rating: number | null;
    category: string;
    image: string | null;
    lat: number;
    lng: number;
  }>;
  zone_advantages: string[];
}

export interface NearbyApiPlace {
  id: string;
  name: string;
  rating: number | null;
  category: string;
  image: string | null;
  lat: number;
  lng: number;
}
